<template>
  <div>
    <div class="overlay"></div>
    <div class="modal_fixed">
      <div v-if="playersDetails.gamesWon === 0">
        <div class="modal_post_game lost modal_cont" id="postGame_modal lost">
          <div class="postGame_content_top">
            <img class="x_close" src="static/images/games/Icon-Close-blue.png" @click="$emit('close')">
          </div>
          <div class="postGame_content_center">
            <div class="postGame_lost">
              <h1>{{ getTranslations.home_post_game_modal_oh_no }}</h1>
              <p>{{ getTranslations.home_post_game_modal_run_out_of_time }}<br>{{ getTranslations.home_post_game_modal_run_out_try_again }}</p>
              <img :src="ohNoImgSrc">
              <p>{{ getTranslations.home_post_game_modal_do_not_give_up }}</p>
              <button type="button" class="postGame_start_btn" @click.prevent="$emit('startNewGame')">
                {{ getTranslations.home_post_game_modal_try_again }}
              </button>
            </div>
          </div>
        </div>
      </div>
      <div v-else>
        <div :class="['modal_post_game ', gameType.toLowerCase(), ' modal_cont']" id="postGame_modal">
          <div class="postGame_content_top">
            <img class="x_close" src="static/images/games/Icon-Close.png" @click="$emit('close')">
            <h4>{{ getTranslations.home_post_game_modal_congr }}</h4>
            <p v-if="gameType === 'ATTENTION'">{{ getTranslations.home_post_game_modal_you_solved }} {{
              playersDetails.gamesWon }}
              {{ getTranslations.home_post_game_modal_attention }} {{ getTranslations.home_post_game_modal_problems
              }}</p>
            <p v-if="gameType === 'LOGIC'">{{ getTranslations.home_post_game_modal_you_solved }} {{
              playersDetails.gamesWon }}
              {{ getTranslations.home_post_game_modal_logic }} {{ getTranslations.home_post_game_modal_problems }}</p>
            <p v-if="gameType === 'MEMORY'">{{ getTranslations.home_post_game_modal_you_solved }} {{
              playersDetails.gamesWon }}
              {{ getTranslations.home_post_game_modal_memory }} {{ getTranslations.home_post_game_modal_problems }}</p>
          </div>
          <div class="postGame_content_center">
            <div class="postGame_stats_row">
              <div class="postGame_stats">
                <p>{{ playersDetails.bonusPoints }}</p>
                <label>{{ getTranslations.home_post_game_modal_bonus_points }}</label>
              </div>
              <div class="vertical_line"></div>
              <div class="postGame_stats">
                <p>{{ playersDetails.iqPoints }}</p>
                <label>{{ getTranslations.home_post_game_modal_game_iq }}</label>
              </div>
            </div>
            <template v-if="!!playersDetails.gamesPlayed">
              <h1>{{ getTranslations.home_post_game_modal_game_accuracy }}</h1>

              <div class="postgame progressdiv attention" :data-percent="calculatePercentage">
                <svg class="progress" width="178" height="178" viewport="0 0 100 100" version="1.1"
                     xmlns="http://www.w3.org/2000/svg">
                  <circle r="81" cx="89" cy="89" fill="transparent" stroke-dasharray="502.4"
                          stroke-dashoffset="0"></circle>
                  <circle class="bar" r="81" cx="89" cy="89" fill="transparent" stroke-dasharray="502.4"
                          stroke-dashoffset="0"></circle>
                </svg>
              </div>
            </template>

            <h3>{{ getTranslations.home_post_game_modal_recommendation_title }}</h3>

            <div class="recomendation_text">
              {{ recommendationText() }}
            </div>

            <button type="button" class="postGame_start_btn" @click.prevent="$emit('startNewGame')">
              {{ getTranslations.home_post_game_modal_new_game }}
            </button>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint no-console: "off" */
import { mapGetters, mapState } from 'vuex';
import { startProgressBar } from '../../../../common/jQuery';
import SkinMixin from '@/common/mixins/skin';

export default {
  name: 'post-game-brainiac',
  mixins: [SkinMixin],
  data() {
    return {
      iqLevel: {
        GENIUS: 'Genius',
        SUPERIOR: 'Superior',
        AVERAGE: 'Average',
      },
      numOfPossibleTexts: 2,
    };
  },
  mounted() {
    this.$nextTick(() => {
      startProgressBar();
    });
  },
  methods: {
    /* eslint-disable */
    calculateIqLevel() {
      return (this.playersDetails.iqPoints >= 140) ? this.iqLevel.GENIUS : (this.playersDetails.iqPoints < 140
      && this.playersDetails.iqPoints >= 120 ? this.iqLevel.SUPERIOR : this.iqLevel.AVERAGE);
    },
    recommendationText() {
      const index = Math.floor(Math.random() * this.numOfPossibleTexts) + 1;
      const iqLevel = this.calculateIqLevel().toLowerCase();
      return this.getTranslations['home_post_game_modal_recommendation_' +
      `${this.gameType.toLowerCase()}_` + `${this.gameMode.toLowerCase()}_` + `${iqLevel}` + '_text.' + `${index}`] ||
        this.getTranslations['home_post_game_modal_recommendation_' +
      `${this.gameType.toLowerCase()}_` + `${this.gameMode.toLowerCase()}_` + `${iqLevel}` + '_text.1'] || '';
     /* eslint-enable */
    },
  },
  computed: {
    ohNoImgSrc() {
      return this.$_skinImage({ fileName: 'games/OH_NO0.png', skins: [100] });
    },
    ...mapGetters('i18n', [
      'getTranslations',
    ]),
    ...mapState('game', [
      'gameType',
      'gameMode',
      'playersDetails',
    ]),
    calculatePercentage() {
      return Math.round((this.playersDetails.gamesWon / this.playersDetails.gamesPlayed) * 100);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/home/modals/postgame/PostGameBrainiac.vue